import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import {
  NotificationType,
  ShiveNotificationService,
} from '../../services/controls/shive-notification.service';
import * as fromGenerateFileActions from './generate-pdf.actions';
import { map, take } from 'rxjs/operators';
import { GeneratedPdfModel } from '../../models/pdf/generated-pdf.model';
import { GeneratePdfPostModel } from '../../models/pdf/generate-pdf-post.model';

@Injectable({
  providedIn: 'root',
})
export class GeneratePdfHttpService {
  private readonly store = inject(Store);
  private readonly shiveNotificationService = inject(ShiveNotificationService);
  private readonly actions$ = inject(Actions);

  constructor() {
    this.handleHttpCallbacks();
  }

  public generatePdf(printPath: GeneratePdfPostModel): Observable<GeneratedPdfModel> {
    this.store.dispatch(fromGenerateFileActions.generatePdf({ payload: printPath }));

    return this.actions$.pipe(
      ofType(fromGenerateFileActions.pdfGenerated),
      map((result) => result.payload),
      take(1),
    );
  }

  private handleHttpCallbacks(): void {
    this.actions$.pipe(ofType(fromGenerateFileActions.pdfGenerated)).subscribe(() => {
      // const message = this.localizationService.getTranslation(payload.responseCode);
      this.shiveNotificationService.show(NotificationType.Success);
    });
  }
}
